import React from 'react';
import { styled, LazyImage } from '@teko/ui';

const StyledProductHeader = styled.div`
  position: sticky;
  padding: 8px 16px;
  background-color: #fff;
  z-index: 100;
  top: 48px;
  left: 0;
  right: 0;
  width: 100%;
  -webkit-backface-visibility: hidden;
  display: flex;
  box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.08);
  > div {
    &:first-child {
      img {
        width: 32px;
        height: 32px;
      }
    }

    &:nth-child(2) {
      font-size: 12px;
      flex-grow: 2;
      padding: 3px 6px;
      line-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
    }

    &:last-child {
      font-weight: 700;
      font-size: 12px;
      white-space: nowrap;
      line-height: 16px;
    }
  }
`;
const ProductHeaderMobile = ({ image, name, price }) => {
  return /* @__PURE__ */ React.createElement(StyledProductHeader, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(LazyImage, {
    src: image || "",
    imageWidth: 50,
    width: 32,
    height: 32,
    alt: "productImage"
  })), /* @__PURE__ */ React.createElement("div", null, name), /* @__PURE__ */ React.createElement("div", null, price));
};

export { ProductHeaderMobile };
